module.exports = __webpack_public_path__ + "img/josefinatapia.7b718e23.jpg";